export const CHECKBOX = 'checkbox';
export const RADIO = 'radio';
export const FILE = 'file';

// allowed formats :
//  - national number starting with 0, 8 to 10 digits (ex : 06 12 34 56 78, 0475 12 25 12, 02 555 12 34)
//  - international number prefixed with + or 00 for FR, BE, IT, ES, CH (ex : +33 6 12 34 56 78, 0032 475 12 25 12)
export const PHONENUMBER_REGEX = /^(?:(?:\+|00)(?:33|32|39|34|41)\s*\d(?:[\s.-]*\d){7,9}|(?:34|41|0)\s*[1-9](?:[\s.-]*\d){7,9})$/;
export const DATE_REGEX = /^\d{1,2}\/\d{1,2}\/\d{4}$/i;
export const PASSWORD_REGEX = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{4,}$/i;
export const PASSWORD_MINLENGTH = 6;
export const PASSWORD_MAXLENGTH = 100;
export const BIC_REGEX = /^[A-Z0-9]{8,}$/i;



// WEBPACK FOOTER //
// ./src/components/form/constants.js